import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import {listStructureAttributes} from '../utils/utilsDataDictionary';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListStructureAttributes extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Attributes : null
        };

        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    const onLoad = function(arr){
        this.setState({
            Attributes: arr,
            renderState: 'loaded'
        });
        
        // Call parent's onLoad callback if provided
        if (this.state.onLoad){
            this.state.onLoad(arr.length);
        }
    }.bind(this);

    const onError = function(e){
        this.setState({
            renderState: 'failed',
            errorMessage: e.message
        });
    }.bind(this);

    listStructureAttributes(this.dsd, filters, onLoad, onError);
}

setup(){

    let StateChange = {
        filters: {},
        columns: {
            owner:false,
            datadictionary: false,
            structure: false
        },
        onLoad: null,
        renderState: 'loading'
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);

    this.loadData(StateChange.filters);
        
}



    included(EntityAttribute) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {
            let arrAttributes = this.state.Attributes;
            if (isArray(arrAttributes)){
                if (arrAttributes.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    {this.state.columns.owner &&
                                        <PD.Th>Owner</PD.Th>                            
                                    }
                                    {this.state.columns.datadictionary &&
                                        <PD.Th>Data Dictionary</PD.Th>                            
                                    }
                                    {this.state.columns.structure &&
                                        <PD.Th>Structure</PD.Th>                            
                                    }
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrAttributes.map(
                                    (Attribute, pos) => 
                                    {
                                        if (this.included(Attribute)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                    <PD.Tr key={pos}>
                                                        {this.state.columns.owner &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Attribute.Structure && Attribute.Structure.DataDictionary){
                                                                        if (Attribute.Structure.DataDictionary.Owner){
                                                                            return Attribute.Structure.DataDictionary.Owner.organisation;
                                                                        }
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.datadictionary &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Attribute.Structure && Attribute.Structure.DataDictionary){
                                                                        return <PD.PdNavLink to={"/datadictionary/" + Attribute.Structure.DataDictionary._id} > {Attribute.Structure.DataDictionary.name}</PD.PdNavLink>
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        {this.state.columns.structure &&
                                                            <PD.Td>
                                                                {(() => {
                                                                    if (Attribute.Structure){
                                                                        return <PD.PdNavLink to={"/structure/" + Attribute.Structure._id} > {Attribute.Structure.name}</PD.PdNavLink>
                                                                    }
                                                                    return null;
                                                                })()}
                                                            </PD.Td>
                                                        }
                                                        <PD.Td>
                                                            {Attribute.name}
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <PD.MdPresent>{truncate(Attribute.description, 400)}</PD.MdPresent>
                                                        </PD.Td>
                                                    </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListStructureAttributes_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListStructureAttributes {...props} navigation={navigation} location={location} params={params} />;
  }
